/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, total: NonNullable<unknown> }} Partner_Billing_Board_Page_OfInputs */



/**
* | output |
* | --- |
* | "Page {page} of {total}" |
*
* @param {Partner_Billing_Board_Page_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_page_of = /** @type {((inputs: Partner_Billing_Board_Page_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Page_OfInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.total}`)
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
});